import React, { Fragment, useEffect, useState } from 'react';
import { Formik } from 'formik';
// @ts-ignore
import { BlockPicker } from 'react-color';
import * as Yup from 'yup';
import { Button, Card, Grid, Typography } from '@material-ui/core';
import {
  GQLCurrency,
  GQLLanguage,
  GQLMerchantChannelType,
  GQLParty
} from '@jewelutions/core-crm-server-api-client-domain';

import { ErrorComponent, LoadingSpinner } from '../../../../components';

import { useStyles } from './styles';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { Box } from '../../../../types-hack';
interface IProps {
  party: GQLParty;
}

const mockDelivery = {
  dropship: false,
  warehouse: true,
  method: 'UPS',
  street: 'abc',
  postcode: '223',
  streetNumber: '2',
  city: 'NY',
  country: 'SUA',
  merchantPaysShipping: true
};

const initialValue: any = {
  name: '',
  channelType: GQLMerchantChannelType.Shopify,
  active: false,
  configuration: {
    availableLanguages: [GQLLanguage.English],
    defaultLanguage: GQLLanguage.English,
    primaryCurrency: GQLCurrency.Eur,
    theme: []
  },
  delivery: mockDelivery,
  defaultChannelCatalog: null,
  domain: 'asd',
  createdAt: null,
  id: '',
  partyId: '',
  updatedAt: ''
};

const LookAndFeelSettings: React.FC<IProps> = ({ party }: IProps) => {
  const [errorComponentState, setErrorComponentState] = useState(false);

  const [state, setState] = useState({
    editMode: false,
    colorPicker: '',
    channel: initialValue
  });

  const classes = useStyles();

  const validationSchema = Yup.object({
    domain: Yup.string().required('Domain is required')
  });

  const updateColorPickerState = (newState: string) => {
    setState({
      ...state,
      colorPicker: newState === state.colorPicker ? '' : newState
    });
  };

  const { data, loading, error, refetch } = GQLOperationBuilder.party.getPartyMerchantChannels({
    partyId: party.id
  });

  useEffect(() => {
    if (data) {
      const channel = GQLOperationBuilder.party.merchantChannelArrayFromResponse(data)[0];
      const theme = channel.configuration.theme;
      const mappedTheme = [
        {
          field: 'designerPanelBck',
          title: 'Designer panel background',
          value: theme.designerPanelBck
        },
        {
          field: 'designerPanelContent',
          title: 'Designer panel content',
          value: theme.designerPanelContent
        },
        {
          field: 'designerPanelControlsActiveBck',
          title: 'Designer panel controls active background',
          value: theme.designerPanelControlsActiveBck
        },
        {
          field: 'designerPanelControlsActiveContent',
          title: 'Designer panel controls active content',
          value: theme.designerPanelControlsActiveContent
        },
        {
          field: 'designerPanelControlsInactiveBck',
          title: 'Designer panel controls inactive background',
          value: theme.designerPanelControlsInactiveBck
        },
        {
          field: 'designerPanelControlsInactiveContent',
          title: 'Designer panel controls inactive content',
          value: theme.designerPanelControlsInactiveContent
        },
        {
          field: 'overallDesignerBck',
          title: 'Overall designer background',
          value: theme.overallDesignerBck
        },
        {
          field: 'overallDesignerContent',
          title: 'Overall designer content',
          value: theme.overallDesignerContent
        }
      ];
      const configuration = { ...channel.configuration, theme: mappedTheme };
      setState({ ...state, channel: { ...channel, configuration } });
    }
  }, [data]);

  const refreshQueries = () => {
    refetch();
  };

  if (loading) return <LoadingSpinner />;

  if (error && !errorComponentState)
    return (
      <ErrorComponent
        close={setErrorComponentState}
        details={error?.stack}
        callback={refreshQueries}
        message={error.message}
      />
    );

  return (
    <Fragment>
      <Box pb={10}>
        <Formik
          initialValues={state.channel}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={() => console.log('On Submit not implemented')}
        >
          {({ values, handleSubmit, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <Grid container direction="row" spacing={4}>
                <Grid item xs={12} md={4}>
                  <Card>
                    <Box p={5}>
                      <Typography gutterBottom variant="h6">
                        Designer Look & Feel
                      </Typography>
                      {values?.configuration?.theme?.map((item: any, index: number) => (
                        <Grid key={index} container direction="row" justify="flex-start" spacing={6}>
                          <Grid item xs={12} style={{ position: 'relative' }}>
                            <Card variant={'outlined'}>
                              <label>{item.title}</label>
                              <Button
                                variant="contained"
                                onClick={() => {
                                  updateColorPickerState(item.field);
                                }}
                                disabled={!state.editMode}
                                style={{
                                  backgroundColor: item.value,
                                  width: '100%'
                                }}
                              >
                                {state.colorPicker === item.field ? 'Save' : item.value}
                              </Button>

                              {state.colorPicker === item.field && (
                                <BlockPicker
                                  className={classes.colorPicker}
                                  color={item.value}
                                  onChangeComplete={(selectedColor: any) => {
                                    setFieldValue('theme.backgroundColor', selectedColor.hex);
                                  }}
                                />
                              )}
                            </Card>
                          </Grid>
                        </Grid>
                      ))}
                    </Box>
                  </Card>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      </Box>
    </Fragment>
  );
};

export default LookAndFeelSettings;
